import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { GoogleMap } from '@lib/geo/google/map';
import { SnLonLat, SnLonLatLike } from '@lib/geo/helpers';

import { BaseZoomManagementService } from '../base-zoom-management.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleZoomManagementService extends BaseZoomManagementService {
  private _map?: GoogleMap;

  constructor() {
    super();
  }

  public setMap(map: GoogleMap): void {
    this._map = map;
  }

  public setZoom(zoom: number): void {
    if (!this._map) return;
    this._map.mapInstance.setZoom(zoom);
  }

  public getZoom(): number {
    if (!this._map) return 0;
    return this._map.mapInstance.getZoom() || 0;
  }

  public zoomIn(): void {
    const currentZoom = this.getZoom();
    this.setZoom(currentZoom + 1);
  }

  public zoomOut(): void {
    const currentZoom = this.getZoom();
    this.setZoom(currentZoom - 1);
  }

  public getMaxZoomAtLatLng?(location: SnLonLatLike): Observable<number> {
    // Google Maps specific implementation using MaxZoomService
    return new Observable((observer) => {
      const maxZoomService = new google.maps.MaxZoomService();
      const lonLat = SnLonLat.convert(location);
      const latLng = new google.maps.LatLng(lonLat.lat, lonLat.lon);

      maxZoomService.getMaxZoomAtLatLng(latLng, (result) => {
        if (result.status === google.maps.MaxZoomStatus.OK) {
          observer.next(result.zoom);
        } else {
          observer.next(21); // Default max zoom
        }
        observer.complete();
      });
    });
  }
}
